"use client";

import { datadogRum } from "@datadog/browser-rum";

import { currentConfig } from "@ala/core/constants";

if (currentConfig.datadog) {
  datadogRum.init({
    applicationId: currentConfig.datadog.applicationId,
    clientToken: currentConfig.datadog.clientToken,
    site: "datadoghq.eu",
    service: currentConfig.datadog.service,
    env: currentConfig.datadog.env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackBfcacheViews: true,
    defaultPrivacyLevel: "mask-user-input",
  });
}

export default function DatadogInit() {
  return null;
}
